import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <ContactSection />
        <MediaSection />
        <RankingSection />
        <CommentsSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}